"use client"

import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Textarea } from '@/components/ui/textarea';

import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { IconPhone, IconMail, IconMapPin } from '@tabler/icons-react';

const ContactUs = () => {
  const [form, setForm] = useState({
    name: '',
    email: '',
    partNumber: '',
    message: '',
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleInputChange = (e:any) => {
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e:any) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const response = await fetch('/api/contact-us', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form),
      });

      const data = await response.json();
      if (response.ok) {
        alert('Your message has been sent!');
        setForm({ name: '', email: '', partNumber: '', message: '' });
      } else {
        alert(data.error || 'Something went wrong.');
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      alert('Something went wrong.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 w-full">
      <div className="container mx-auto py-12 px-4">
        <Card className="p-6 shadow-md bg-white">
          <CardHeader>
            <CardTitle className="text-4xl font-bold text-center">Contact Us</CardTitle>
            <CardDescription className="text-center mt-2 text-gray-600">
              We are here to assist you. Reach out to us anytime.
            </CardDescription>
          </CardHeader>
          <CardContent>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-6">
              {/* Contact Details */}
              <div>
                <h2 className="text-2xl font-semibold mb-4">Get in Touch</h2>
                <div className="flex items-center gap-4 mb-6">
                  <IconPhone className="text-primary" size={24} />
                  <p className="text-lg text-gray-700">Phone: +91 9824001636</p>
                </div>
                <div className="flex items-center gap-4 mb-6">
                  <IconMail className="text-primary" size={24} />
                  <p className="text-lg text-gray-700">Email: sales@jalaramautomotive.com</p>
                </div>
                <div className="flex items-center gap-4 mb-6">
                  <IconMapPin className="text-primary" size={24} />
                  <p className="text-lg text-gray-700">
                    Location: Ground Floor, No. 2617, Survey No. 442, Jalaram House,
Changodar Main Road, Near Santhal Circle, Sanathal,
Ahmedabad, Ahmedabad, Gujarat, 382210.
                  </p>
                </div>
                <h2 className="text-2xl font-semibold mb-4">Customer Support</h2>
                <div className="flex items-center gap-4 mb-6">
                  <IconPhone className="text-primary" size={24} />
                  <p className="text-lg text-gray-700">Phone: +91 9737005397</p>
                </div>
                <div className="flex items-center gap-4 mb-6">
                  <IconMail className="text-primary" size={24} />
                  <p className="text-lg text-gray-700">Email: jalaramautomotiveexport@yahoo.com </p>
                </div>
                <p className="text-lg text-gray-600 mt-4">
                  Our experts are ready to assist with your queries, from part number inquiries to
                  service details.
                </p>
              </div>
            

              {/* Contact Form */}
              <div>
                <h2 className="text-2xl font-semibold mb-4">Send Us a Message</h2>
                <form className="space-y-4" onSubmit={handleSubmit}>
                  <Input
                    type="text"
                    name="name"
                    value={form.name}
                    onChange={handleInputChange}
                    placeholder="Your Name"
                    className="w-full"
                    required
                  />
                  <Input
                    type="email"
                    name="email"
                    value={form.email}
                    onChange={handleInputChange}
                    placeholder="Your Email"
                    className="w-full"
                    required
                  />
                  <Input
                    type="text"
                    name="partNumber"
                    value={form.partNumber}
                    onChange={handleInputChange}
                    placeholder="Part Number (if applicable)"
                    className="w-full"
                  />
                  <Textarea
                    name="message"
                    value={form.message}
                    onChange={handleInputChange}
                    placeholder="How can we help you?"
                    className="w-full"
                    rows={5}
                    required
                  />
                  <Button
                    type="submit"
                    className={`w-full text-white ${isSubmitting ? 'bg-gray-400' : 'bg-primary'}`}
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? 'Submitting...' : 'Submit'}
                  </Button>
                </form>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default ContactUs;
